import React from 'react';
import { useParams } from 'react-router-dom';

import {
  useGetSbatGroupQuery,
  useGetPlaylistContentQuery,
} from 'features/classCreation';
import PlaylistValidatorTabs from './PlaylistValidatorTabs';
import IngestButton from './IngestButton';
import ErrorLayout from 'components/ErrorLayout';
import Loader from 'components/Loader';
import SectionHeading from 'components/SectionHeading';
import styles from './EditSbatGroupPlaylistPage.module.scss';

function EditSbatGroupPlaylistPage() {
  const { sbatGroupId } = useParams();
  const {
    isLoading: isSbatGroupLoading,
    error: sbatGroupError,
    data: sbatGroup,
    isSuccess,
    refetch,
  } = useGetSbatGroupQuery(Number(sbatGroupId));

  const { isLoading: isPlaylistContentLoading, data: playlistContent } =
    useGetPlaylistContentQuery(
      sbatGroup?.data?.academy_topic?.playlist_owner?.playlist_id,
      {
        skip: !isSuccess || !sbatGroup?.data?.academy_topic?.playlist_owner,
      }
    );

  if (isSbatGroupLoading || isPlaylistContentLoading) {
    return <Loader />;
  } else if (sbatGroupError) {
    return (
      <ErrorLayout
        title="Failed to load class details"
        message={
          sbatGroupError.data?.message ||
          'Something went wrong! Try again later'
        }
        actionFn={refetch}
      />
    );
  } else {
    const { data: sbatGroupData } = sbatGroup || {};
    const { academy_topic: academyTopic } = sbatGroupData || {};
    const { title } = academyTopic || {};
    const { data: playlistContentData } = playlistContent || {};
    const { name } = playlistContentData || {};
    const playlistName = name || title;

    return (
      <div className="p-l">
        <SectionHeading
          title="CUE CARD VALIDATOR"
          subtitle="Create, verify & edit cue card playlists"
        />
        <div className={styles.playlistName}>{playlistName}</div>
        <PlaylistValidatorTabs playlist={playlistContentData} />
        <IngestButton
          sbatGroup={sbatGroupData}
          playlist={playlistContentData}
        />
      </div>
    );
  }
}

export default EditSbatGroupPlaylistPage;
